export default __webpack_public_path__ + "6e62e94.png";